import { Routes } from '@angular/router';
import { DashboardPageComponent } from './dashboard-page/dashboard-page.component';
import { ZipManagerRouting } from '@aipb/gulliver/zip-manager/routing';

export const DashboardRoutes: Routes = [
  {
    path: ZipManagerRouting.dashboardDefaultPath,
    component: DashboardPageComponent
  }
];
